<template>
  <table class="Table">
    <app-table-header
      :columns="columns"
    />
    <tbody>
      <tr>
        <td :colspan="columns.length">
          <div class="row_noData">
            {{ title }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
  defineOptions({
    name: 'AppEmptyData'
  });

 const props = defineProps({
    columns: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'No Data'
    }
 });
</script>

<style lang="scss">
  .row_noData {
    background-color: $white;
    box-shadow: 0 .02rem .05rem rgba(222, 219, 214, .4);
    min-height: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: .06rem;
    padding: .2rem;
  }
</style>
